import { shade } from 'polished';
import styled from 'styled-components';

export const Button = styled.button`
  background: transparent;
  border-radius: 8px;
  border: 1px solid transparent;

  width: 280px;
  height: 48px;

  display: flex;
  justify-content: center;
  align-items: center;

  transition: all 0.5s;

  color: #076bee;
  font-weight: bold;
  font-size: 14px;
  line-height: 14px;

  p {
    text-transform: uppercase;
  }
`;
